import React, { useEffect, useState } from "react";
import styled from "styled-components";
import { UserRole } from "../../../lib/types";
import {
  GrayButton,
  PurpleButton,
  TomatoButton,
} from "../../../components/Layout/CommonStyle";
import toast from "react-hot-toast";
import { safeParseInt } from "../../../components/Common/Util";
import "dayjs/locale/ko";
import { User } from "lib/models";

interface Props {
  newMode: boolean;
  user: User;
  onClose: () => void;
  onSave: (user: User, password: string, newMode: boolean) => Promise<void>;
  onDelete: (user: User) => void;
}

function UserPopup(props: Props) {
  const [user, setUser] = useState<User | undefined>(undefined);
  const [password, setPassword] = useState("");

  const handleSave = async () => {
    if (!user) {
      return;
    }

    await props.onSave(user, password, props.newMode);

    props.onClose();
  };

  const handleDelete = async () => {
    if (!user) {
      return;
    }

    if (user.id === 0) {
      toast.error("삭제할 데이터가 없습니다.");
      return;
    }

    if (!window.confirm("삭제하시겠습니까?")) {
      return;
    }

    props.onDelete(user);

    props.onClose();
  };

  const handleCancel = () => {
    props.onClose();
  };

  useEffect(() => {
    if (!props.user) {
      return;
    }

    if (!props.user) {
      const newUser = {
        id: 0,
        email: "",
        name: "",
        role: UserRole.USER,
      } as User;

      setUser(newUser);
    } else {
      setUser(props.user);
    }
  }, [props.user]);

  const onChangeName = (e: React.ChangeEvent<HTMLInputElement>) => {
    if (!user) return;

    setUser({ ...user, name: e.target.value.trim() });
  };

  const onChangeEmail = (e: React.ChangeEvent<HTMLInputElement>) => {
    if (!user) return;

    setUser({ ...user, email: e.target.value.trim() });
  };

  const onChangeRole = (e: React.ChangeEvent<HTMLSelectElement>) => {
    if (!user) return;

    const role = safeParseInt(e.target.value);
    setUser({ ...user, role: role });
  };

  const onChangePassword = (e: React.ChangeEvent<HTMLInputElement>) => {
    setPassword(e.target.value.trim());
  };

  return (
    <Container>
      <Title>사용자 정보</Title>
      <InputField>
        <label>ID</label>
        <input type="text" value={user?.id} />
      </InputField>
      <InputField>
        <label>이름</label>
        <input type="text" value={user?.name} onChange={onChangeName} />
      </InputField>
      <InputField>
        <label>아이디</label>
        <input type="text" value={user?.email} onChange={onChangeEmail} />
      </InputField>
      <InputField>
        <label>비밀번호</label>
        <input
          type="password"
          value={password}
          onChange={onChangePassword}
          placeholder={props.newMode ? "" : "변경이 필요할때 입력"}
        />
      </InputField>
      <InputField>
        <label>역할</label>
        <select value={user?.role} onChange={onChangeRole}>
          <option value={UserRole.USER}>사용자</option>
          <option value={UserRole.MANAGER}>매니저</option>
          <option value={UserRole.ADMIN}>관리자</option>
        </select>
      </InputField>
      <Buttons>
        {props.newMode ? (
          <div></div>
        ) : (
          <PurpleButton onClick={() => handleDelete()}>삭제</PurpleButton>
        )}
        <div>
          <TomatoButton onClick={() => handleSave()}>저장</TomatoButton>
          <GrayButton onClick={handleCancel}>취소</GrayButton>
        </div>
      </Buttons>
    </Container>
  );
}

const Container = styled.div`
  /* width: 800px; */
  margin-top: -20px;
`;

const Title = styled.div`
  margin-top: 20px;
  padding: 5px 40px;
  box-sizing: border-box;
  text-align: center;
`;

const InputField = styled.div`
  display: grid;
  grid-template-columns: 80px 1fr;
  margin: 15px 0 0;
  column-gap: 20px;
  align-items: center;
  padding: 0 0px;

  label:nth-child(1) {
    width: 80px;
    text-align: right;
  }
  input {
    padding: 8px;
    border: 1px solid #c5c5c5;
    border-radius: 5px;
  }
  input.MuiInputBase-input {
    border: none;
  }
  select {
    padding: 8px;
    margin: 1px;
    box-sizing: border-box;
    border: 1px solid #c5c5c5;
    border-radius: 5px;
  }
  td {
    text-align: center;
    input {
      width: 100px;
      text-align: center;
    }
  }
  table,
  tr,
  td {
    padding: 0;
    margin: 0;
  }
  textarea {
    border: 1px solid #eee;
  }

  & > select {
    width: 231px;
    box-sizing: border-box;
  }
  & > input {
    width: 231px;
    box-sizing: border-box;
  }

  @media (max-width: 640px) {
    grid-template-columns: 1fr;
    row-gap: 6px;
    label:nth-child(1) {
      width: auto;
      text-align: left;
    }
    & > select,
    & > input {
      width: 100%;
    }
  }
`;

const Buttons = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  padding-top: 30px;
`;

export default UserPopup;
